import { msg } from '@lingui/core/macro'
import { useLingui } from '@lingui/react'
import { Markdown } from '../Markdown'

/** Instructions section of the assignment hero card. */
export const InstructionsBlock = ({
  instructions,
}: { instructions: string }) => {
  const { _ } = useLingui()
  return (
    <div className='assignment-detail__hero-block'>
      <div className='assignment-detail__section-title'>
        {_(msg`Instructions`)}
      </div>
      <div className='assignment-detail__section-body assignment-detail__markdown'>
        <Markdown>{instructions}</Markdown>
      </div>
    </div>
  )
}
